var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566,
    height: 527,
    viewBox: "0 0 566 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.24 37.5763L155.82 0C-13.1356 113.661 -107 251.761 -107 365.422C-107 475.325 -26.2616 527 42.2518 527C128.607 527 189.611 453.711 189.611 376.695C189.611 311.883 148.311 256.451 92.9236 235.769C76.9742 230.117 61.9559 225.428 61.9559 198.192C61.9559 163.442 87.3067 111.797 180.24 37.5763ZM552.874 37.5763L528.454 0C361.361 113.661 265.634 251.761 265.634 365.422C265.634 475.325 348.235 527 416.748 527C504.034 527 566 453.711 566 376.695C566 311.883 523.769 256.451 466.489 235.769C450.539 230.117 436.452 225.428 436.452 198.192C436.452 163.442 462.734 111.767 552.844 37.5462L552.874 37.5763Z",
    fill: "black",
    fillOpacity: 0.03
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSli);
export default __webpack_public_path__ + "static/media/sli.accd470c7966553373125262ef6c6bc0.svg";
export { ForwardRef as ReactComponent };